import React, { useState } from 'react'
import { MyModal } from '~/components/ui/MyModal'
import styled from 'styled-components'
import classNames from 'classnames'
import { Input, message } from 'antd'
import { useMutation } from '@apollo/client'

import styles from './AIShareTitleModal.module.css'
import { MyBtn } from '~/components/ui/MyBtn'
import { MyCheckbox } from '~/components/ui/MyCheckbox'
import { graphQLErrorMessage } from '~/utils'
import { TEXT_DETECTION } from '~/graphqls/gqls'
import { textDetection, textDetectionVariables, Scene } from '~/graphqls/types'

const CustomMyModal = styled(MyModal)`
  .ant-modal-body {
    padding: 16px;
  }

  .ant-modal-close {
    display: none;
  }
`
/** 分享参数 */
export type IAiShareTitleItems = {
  /** 标题 */
  shareTitle: string
  /** 底图能否查看 */
  visibleInitImage: boolean
}
export default function AIShareTitleModal({
  visible,
  setVisible,
  showInitImage = false,
  onSuccess,
}: {
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  /** 展示分享底图选项 */
  showInitImage?: boolean
  onSuccess: (shareItems: IAiShareTitleItems) => void
}) {
  const [shareTitle, setShareTitle] = useState('')
  const [fetchTextDetect] = useMutation<textDetection, textDetectionVariables>(
    TEXT_DETECTION
  )

  const handleConfirm = async () => {
    const param = {
      shareTitle,
      visibleInitImage: showInitImage ? visibleInitImage : false,
    }
    try {
      // 有标题文字则需要检测
      if (shareTitle) {
        const checkRes = await fetchTextDetect({
          variables: {
            input: {
              text: shareTitle,
              scene: Scene.APP_SHARE_AI_ARTWORK_TITLE,
            },
          },
        })
        if (checkRes?.data?.commonMutation?.success) {
          onSuccess(param)
        }
      } else {
        onSuccess(param)
      }
    } catch (err) {
      message.destroy()
      message.error(graphQLErrorMessage(err) || '自定义标题创建失败')
    }
  }

  const [visibleInitImage, setVisibleInitImage] = useState(true)

  return (
    <CustomMyModal
      open={visible}
      title={null}
      onCancel={() => setVisible(false)}
      maskStyle={{
        backgroundColor: 'rgba(0,0,0,0.8)',
      }}
      width={270}
      footer={null}
      // transitionName=""
      maskTransitionName=""
      centered
      dark
    >
      <div className="font-medium text-base mb-2 text-center text-neutral-800">
        分享图展示信息
      </div>
      <div
        className={classNames(
          styles.textArea,
          showInitImage && 'border-[2px] border-solid border-neutral-300 '
        )}
      >
        <Input.TextArea
          maxLength={20}
          placeholder="自定义标题（可选）"
          showCount
          autoSize={{ minRows: 3 }}
          value={shareTitle}
          onChange={e => {
            setShareTitle(e.target.value.trim())
          }}
        />
      </div>
      {showInitImage && (
        <div
          className="flex items-center mt-2"
          onClick={() => {
            setVisibleInitImage(!visibleInitImage)
          }}
        >
          <MyCheckbox $dark checked={visibleInitImage} />
          <span className="text-xs text-neutral-400 font-semibold ml-2">
            展示参考（对比）图
          </span>
        </div>
      )}
      <div className="flex gap-3 mt-4">
        <MyBtn
          $dark={true}
          className="flex-1"
          onClick={() => setVisible(false)}
        >
          取消
        </MyBtn>
        <MyBtn
          $dark={true}
          className="flex-1"
          type="primary"
          onClick={handleConfirm}
        >
          提交
        </MyBtn>
      </div>
    </CustomMyModal>
  )
}
